module.exports = __webpack_public_path__ + "media/images/categories/icon_cat21-5fa52cfda57034f29147c55ffdddce16.svg";